"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * IScoreGolfPlus Development
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 1.1.56-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIErrorToJSON = exports.APIErrorFromJSONTyped = exports.APIErrorFromJSON = void 0;
function APIErrorFromJSON(json) {
    return APIErrorFromJSONTyped(json, false);
}
exports.APIErrorFromJSON = APIErrorFromJSON;
function APIErrorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'messages': json['messages'],
    };
}
exports.APIErrorFromJSONTyped = APIErrorFromJSONTyped;
function APIErrorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'messages': value.messages,
    };
}
exports.APIErrorToJSON = APIErrorToJSON;
